/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable import/no-unresolved */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { memo, useEffect, useState } from "react";
import { useFormik } from "formik";
import TextField from "@mui/material/TextField";
import { filterOptionsInitialValue } from "src/helpers/Dashboard";
import store from "src/redux/store";
import { searchDashboardData, setFilterOptions } from "src/redux/Actions/dashboard";
import CancelIcon from "@mui/icons-material/Cancel";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import useURLQuery from "src/utils/hooks/useQuery";
import { removeUrlParam, setUrlParam } from "src/helpers/Dashboard/resources";
import { Button } from "@mui/material";
import StorageService from "src/utils/Storage/storageService";
import { roleIDs } from "src/config/constant";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import Resources from "../../../config/Resources";
import QueryFilterModal from "./QueryFilterOptions";
import PAFUpload from "./PAFUpload";

function QueryOptions() {
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [isPAFUploadActive, setIsPAFUploadActive] = useState(false);
  const searchValue = useAppSelector((state) => state.dashboard.searchQuery);
  const urlSearch = useURLQuery().get("search");
  const [search, setSearch] = useState(searchValue);
  const user = StorageService.getFromLocalStorage("user");

  const formik = useFormik({
    enableReinitialize: true,
    validateOnMount: true,
    validateOnChange: true,
    validateOnBlur: true,
    initialValues: filterOptionsInitialValue,
    onSubmit: (fieldValues) => {
      // store.dispatch(setFilterSaved(true));
      store.dispatch(setFilterOptions(fieldValues));
      setIsFilterActive(false);
    },
    onReset: () => {
      store.dispatch(setFilterOptions(filterOptionsInitialValue));
      // setIsFilterActive(false);
    }
  });

  const handleCloseClick = () => {
    setIsFilterActive((prev) => !prev);
  };

  useEffect(() => {
    if (urlSearch) {
      store.dispatch(searchDashboardData(urlSearch || ""));
      setSearch(urlSearch || "");
    }
  }, []);

  return (
    <>
      {isPAFUploadActive && (
        <PAFUpload
          setActive={() => {
            document.body.style.overflowY = "scroll";
            setIsPAFUploadActive((prev) => !prev);
          }}
        />
      )}
      <QueryFilterModal isOpen={isFilterActive} onCloseClick={handleCloseClick} formik={formik} />
      <div className="md:mt-0 flex flex-col md:flex-row justify-between items-center space-x-2 md:space-y-0">
        <h2 className="hidden md:block font-bold xl:text-xl leading-6 font-montserrat">
          Applications
        </h2>
        <div className="lg:flex space-y-2 lg:space-y-0">
          <div className="flex flex-row space-x-5 md:pr-0 pr-2 items-center">
            <div className="md:max-sm:flex">
              <TextField
                inputMode="search"
                variant="standard"
                margin="none"
                focused={false}
                value={search}
                onChange={(event) => setSearch(event.target.value)}
                InputProps={{
                  startAdornment: (
                    <img
                      src={Resources.images.Dashboard.searchIcon}
                      alt="search"
                      className="text-black ml-2"
                    />
                  ),
                  endAdornment: (
                    <CancelIcon
                      className="!cursor-pointer !h-5"
                      onClick={() => {
                        setSearch("");
                        if (searchValue) {
                          removeUrlParam("search");
                          store.dispatch(searchDashboardData(""));
                        }
                      }}
                    />
                  ),
                  disableUnderline: true,
                  classes: {
                    inputAdornedStart: "!pl-2",
                    root: "!h-10 !w-auto !px-1 !bg-whiteEdgar !rounded-lg !text-black",
                    input: "!text-black !font-medium !text-sm !font-montserrat"
                  }
                }}
                inputProps={{
                  onKeyPress: (event) => {
                    if (
                      event.key === "Enter" &&
                      (event.target as HTMLInputElement)?.value &&
                      searchValue.trim() !== (event.target as HTMLInputElement)?.value?.trim()
                    ) {
                      setUrlParam((event.target as HTMLInputElement)?.value?.trim());
                      store.dispatch(
                        searchDashboardData((event.target as HTMLInputElement)?.value?.trim())
                      );
                    }
                  }
                }}
                placeholder="Search"
                className="sm:max-md:w-60 lg:w-88"
              />
            </div>
            <div className="hidden sm:flex">
              <div
                onClick={handleCloseClick}
                className="font-montserrat font-medium px-4 py-1.5 border-1.5 rounded-md border-hotShot flex items-center justify-center md:space-x-2 cursor-pointer"
              >
                <span>Filter by</span>
                <span>
                  <img
                    src={
                      isFilterActive
                        ? Resources.images.Select.upIcon
                        : Resources.images.Select.downIcon
                    }
                    alt="arrow"
                  />
                </span>
              </div>
            </div>
            <div className="sm:hidden">
              <img
                onClick={handleCloseClick}
                src={Resources.images.Dashboard.filterIcon}
                alt="filter"
                className="!text-center"
              />
            </div>
            {(user?.role === roleIDs.nbgo ||
              user?.role === roleIDs.superAdmin ||
              user?.role === roleIDs.admin) && (
              <div>
                <Button
                  variant="contained"
                  classes={{ contained: "!rounded-lg" }}
                  onClick={() => setIsPAFUploadActive((prev) => !prev)}
                  className="rounded-lg"
                >
                  <FileUploadOutlinedIcon fontSize="small" />
                  <span>PAF</span>
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default memo(QueryOptions);
